<!--人文美育-视频库管理-->
<template>
    <div class="course-container" >
        <div class="base-create-container">
            <!--创建-->
            <div class="head-container">
                <div class="left-head-container">
                    <a class="l-a" @click="backList">五馆合一</a> / <a class="l-a" @click="backMuseum">{{museumName}}</a>

                </div>
                <div class="right-head-container">{{form.courseName}}</div>
            </div>
            <div class="info-container">
                <el-row :gutter="10">
                    <el-col :span="1">
                        <div class="operation-item-container">
                            <div class="operation-item-icon" @click.stop="isTheme = !isTheme">
                                <img style="width:18px;"  v-if="!isTheme"  src="../../assets/image/video-zj.png" alt="">
                                <img style="width:18px;" v-if="isTheme"  src="../../assets/image/video-zjAc.png" alt="">
                            </div>
                            <div @click.stop="isTheme = !isTheme" :class="isTheme?'operation-item-name-active':'operation-item-name'" style="">主题</div>
                        </div>

                        <div class="operation-item-container">
                            <div class="operation-item-icon" @click="viewVideoFile">
                                <img style="width:22px;"  src="../../assets/image/video-file.png" alt="">
                            </div>
                            <div @click="viewVideoFile" class="operation-item-name" style="">资料</div>
                        </div>

                        <div class="operation-item-container">
                            <div class="operation-item-icon" @click="userIsCollect">
                                <img v-if="!form.isCollect" style="width:22px;"  src="../../assets/image/collect.png" alt="">
                                <img v-if="form.isCollect" style="width:22px;"  src="../../assets/image/collect-blue.png" alt="">
                            </div>
                            <div @click="userIsCollect" :class="form.isCollect?'operation-item-name-active':'operation-item-name'" style="">收藏</div>
                        </div>

                        <div class="operation-item-container">
                            <div class="operation-item-icon" @click="userIsLike">
                                <img v-if="!form.isLike" style="width:18px;"  src="../../assets/image/dz.png" alt="">
                                <img v-if="form.isLike" style="width:18px;"  src="../../assets/image/dz-blue.png" alt="">
                            </div>
                            <div @click="userIsLike" :class="form.isLike?'operation-item-name-active':'operation-item-name'">点赞</div>
                        </div>
                    </el-col>

                    <el-col class="btx" :style="isTheme ? 'opacity:1;' : 'opacity:0;width:0px;'" :span="10">
                        <div style="padding:10px 10px 10px 0;height: calc(100vh - 140px);overflow: auto;">
                            <div @click="changeTheme(1)" :class="themeNo===1?'theme-container-active':'theme-container'" v-if="vList1&&vList1.length>0">社会主义先进文化</div>
                            <div @click="changeTheme(2)" :class="themeNo===2?'theme-container-active':'theme-container'" v-if="vList2&&vList2.length>0">革命文化</div>
                            <div @click="changeTheme(3)" :class="themeNo===3?'theme-container-active':'theme-container'" v-if="vList3&&vList3.length>0">中华优秀传统文化世界优秀文化遗产</div>
                            <div @click="changeTheme(4)" :class="themeNo===4?'theme-container-active':'theme-container'" v-if="vList4&&vList4.length>0">法治意识</div>
                            <div @click="changeTheme(5)" :class="themeNo===5?'theme-container-active':'theme-container'" v-if="vList5&&vList5.length>0">国家安全</div>
                            <div @click="changeTheme(6)" :class="themeNo===6?'theme-container-active':'theme-container'" v-if="vList6&&vList6.length>0">民族团结</div>
                            <div @click="changeTheme(7)" :class="themeNo===7?'theme-container-active':'theme-container'" v-if="vList7&&vList7.length>0">生态文明</div>
                            <div @click="changeTheme(8)" :class="themeNo===8?'theme-container-active':'theme-container'" v-if="vList8&&vList8.length>0">海洋权益</div>
                            <div @click="changeTheme(9)" :class="themeNo===9?'theme-container-active':'theme-container'" v-if="vList9&&vList9.length>0">经济社会发展新变化科学技术进步新发展</div>
                        </div>
                    </el-col>

                    <el-col :span="17">
                        <el-card shadow="never" class="video-card">
                            <div id="player">

                            </div>
                            <div class="mt5 ml5" style="display: flex;align-items: center;">
                                <el-icon :size="22">
                                    <ChatDotSquare />
                                </el-icon>
                                &nbsp;<span style="margin-top: -2px;">{{ this.form.commentList && this.form.commentList.length }}</span>
                            </div>
                            <div class="" style="">
                                <el-empty :image-size="80" v-if="this.form.commentList && this.form.commentList.length == 0"
                                          description="暂无评论" />
                                <div v-for="(item, index) in this.form.commentList" class="mt15"
                                     style="border-bottom: 1px solid #efefef;padding-bottom: 10px;">
                                    <div style="display: flex;align-items: center;justify-content: space-between;">
                                        <div style="display: flex;align-items: center;color: #959494;">
                                            <el-avatar :size="30" :src="item.avatar" />
                                            <div class="ml10">{{ item.trueName }}</div>
                                        </div>
                                        <div class="mr15 cursor" v-if="userId === item.userId">
                                            <el-popconfirm confirm-button-text="是" cancel-button-text="否" :icon="InfoFilled"
                                                           icon-color="#626AEF" title="确定确定删除该评论" @confirm="delComment(item, index)">
                                                <template #reference>
                                                    <el-icon>
                                                        <Delete />
                                                    </el-icon>
                                                </template>
                                            </el-popconfirm>
                                        </div>
                                    </div>
                                    <div style="padding-left: 40px;">
                                        {{ item.content }}
                                    </div>
                                    <div style="padding-left: 40px;color: #959494;font-size: 12px;" class="mt5">
                                        {{ timestampToTime(item.commentTime) }}
                                    </div>
                                </div>
                            </div>
                            <div class="mt10">
                                <div class="mt-4 zsss">
                                    <el-input v-model="content" placeholder="添加评论">
                                        <template #append>
                                            <div class="cursor" @click="createContent" style="width: 100%;padding:5px 20px;display: flex;">
                                                <el-icon :size="24">
                                                    <Position />
                                                </el-icon>
                                            </div>
                                        </template>
                                    </el-input>
                                </div>
                            </div>
                        </el-card>
                    </el-col>
                    <el-col :span="6">
                        <div class="v-info">
<!--                            <div style="display: flex;align-items:center;">-->
<!--                                <el-avatar :size="35" :src="form.userAvatar + '?_=' + Date.now()" />-->
<!--                                <div class="v-info-content ml5">{{ form.userName }}</div>-->
<!--                            </div>-->
                            <div class="v-info-title">
                                课程简介
                            </div>
                            <div class="v-info-content">
                                {{ form.introduction }}
                            </div>
                            <div class="v-info-title mt10">
                                视频列表
                            </div>
                            <div class="v-item cursor" @click="viewVideo(item)" v-for="item in videoList">
                                <div>
                                    <img :style="this.vid === item.videoId ? 'border:1px solid #409eff' : ''"
                                         class="w-100 csvideo" :src="item.coverUrl + '?x-oss-process=video/snapshot,t_1,m_fast'"
                                         alt="">
                                </div>
                                <div class="text-one" :style="this.vid  === item.videoId ? 'color:#409eff' : ''">
                                    {{ item.title }}
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>

    <el-dialog draggable :title="'附件'" v-model="isVideoFileShow" width="535px">
        <el-table header-cell-class-name="bgf2" show-overflow-tooltip
                  :data="videoFileList"
                  highlight-current-row>
            <el-table-column type="index" align="center" label="序号" width="60" />
            <el-table-column width="240px" align="center" label="文件名称" prop="fileName">
                <template #default="scope">
                    <div  :title="scope.row.fileName" @click="handleViewInfo(scope.row)" style="color: #409efe;" class="text-one cursor">
                        {{ scope.row.fileName }}
                    </div>
                </template>
            </el-table-column>
            <el-table-column fixed="right" width="200" label="操作" align="center">
                <template #default="scope">
                    <el-button type="primary" size="small" @click="handleDownload(scope.row)">下载</el-button>
                    <el-button type="primary" size="small" @click="handleViewInfo(scope.row)">查看</el-button>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import {serviceUrl} from "@/utils/global";
import {infoHumanityCourse} from "@/api/admin/humanityCourse";
import {addOrCancel, commentCreate, commentDelete, likeClick} from "@/api/admin/famousCourse";
import {timestampToTime} from "@/utils/date";
import {downloadFile} from "@/api/adminservice/public";
export default {
    name: "humanityCourse",
    components: {},
    props:{
        courseId:{
            type: String,
            default:null
        },
    },
    watch: {
        courseId(newValue,oldValue){
            this.queryCourseInfo()
        },
    },
    data() {
        return {
            serviceUrl,
            listMode:'list',
            infoMode:'info',
            timestampToTime,
            isVideoFileShow:false,
            isTheme:false,
            token: this.$storage.get("token"),
            userId:JSON.parse(this.$storage.get("userInfo")).userId,
            // courseId:'',
            videoList:[],
            videoFileList:[],
            museumName:'',
            vNo:0,
            vNum:0,
            selVId:'',
            vList1:[], //社会主义先进文化
            vList2:[], //革命文化
            vList3:[], //中华优秀传统文化世界优秀文化遗产
            vList4:[], //法治意识
            vList5:[], //国家安全
            vList6:[], //民族团结
            vList7:[], //生态文明
            vList8:[], //海洋权益
            vList9:[], //经济社会发展新变化科学技术进步新发展
            vodPlayerJs: 'https://player.polyv.net/resp/vod-player/latest/player.js',
            vid:'',
            videoName:'',
            videoWidth:800,
            videoHeight:500,
            form:{},
            content:'',
            themeNo:0,
        }
    },
    computed: {},
    created() {
        this.queryCourseInfo()
    },
    mounted(){
        this.queryCourseInfo()
    },
    methods: {
        backList(){

        },
        backMuseum(){
            this.$emit('change-show-mode', this.listMode);
        },
        viewVideo(row){
            this.destroyed();
            this.vid = row.videoId;
            this.videoName = row.title;
            this.isViewVideoShow = true;
            this.videoFileList = row.fileList;
            setTimeout(() => {
                this.loadPlayerScript(this.loadPlayer);
            })
        },
        loadPlayerScript(callback) {
            if (!window.polyvPlayer) {
                const myScript = document.createElement('script');
                myScript.setAttribute('src', this.vodPlayerJs);
                myScript.onload = callback;
                document.body.appendChild(myScript);
            } else {
                callback();
            }
        },
        loadPlayer() {
            const polyvPlayer = window.polyvPlayer;
            this.player = polyvPlayer({
                wrap: '#player',
                // width: this.videoWidth,
                // height: this.videoHeight,
                vid: this.vid,
            });
        },
        destroyed() {
            if (this.player) {
                this.player.destroy();
            }
        },
        queryCourseInfo(){
            infoHumanityCourse({ courseId: this.courseId }).then(res => {
                if (res.data.code === 1) {
                    this.form = res.data.data;
                    let flag = true;
                    this.vList1 = this.form.videoInfo1;
                    if (flag&&this.vList1&&this.vList1.length>0){
                        flag = false;
                        this.themeNo = 1;
                        this.videoList = this.vList1;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList2 = this.form.videoInfo2;
                    if (flag&&this.vList2&&this.vList2.length>0){
                        flag = false;
                        this.themeNo = 2;
                        this.videoList = this.vList2;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList3 = this.form.videoInfo3;
                    if (flag&&this.vList3&&this.vList3.length>0){
                        flag = false;
                        this.themeNo = 3;
                        this.videoList = this.vList3;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList4 = this.form.videoInfo4;
                    if (flag&&this.vList4&&this.vList4.length>0){
                        flag = false;
                        this.themeNo = 4;
                        this.videoList = this.vList4;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList5 = this.form.videoInfo5;
                    if (flag&&this.vList5&&this.vList5.length>0){
                        flag = false;
                        this.themeNo = 5;
                        this.videoList = this.vList5;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList6 = this.form.videoInfo6;
                    if (flag&&this.vList6&&this.vList6.length>0){
                        flag = false;
                        this.themeNo = 6;
                        this.videoList = this.vList6;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList7 = this.form.videoInfo7;
                    if (flag&&this.vList7&&this.vList7.length>0){
                        flag = false;
                        this.themeNo = 7;
                        this.videoList = this.vList7;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList8 = this.form.videoInfo8;
                    if (flag&&this.vList8&&this.vList8.length>0){
                        flag = false;
                        this.themeNo = 8;
                        this.videoList = this.vList8;
                        this.viewVideo(this.videoList[0])
                    }
                    this.vList9 = this.form.videoInfo9;
                    if (flag&&this.vList9&&this.vList9.length>0){
                        flag = false;
                        this.themeNo = 9;
                        this.videoList = this.vList9;
                        this.viewVideo(this.videoList[0])
                    }
                    if (this.form.museumKey === '1'){
                        this.museumName = '文化馆';
                    }
                    if (this.form.museumKey === '2'){
                        this.museumName = '艺术馆';
                    }
                    if (this.form.museumKey === '3'){
                        this.museumName = '科技馆';
                    }
                    if (this.form.museumKey === '4'){
                        this.museumName = '博物馆';
                    }
                    if (this.form.museumKey === '5'){
                        this.museumName = '图书馆';
                    }
                } else {
                    this.$message.error("请求出错");
                }
            })
        },
        userIsLike() {
            likeClick({ relationId: this.form.courseId }).then(res => {
                if (res.data.code === 1) {
                    if (this.form.isLike === 1) {
                        this.$message.success("已取消");
                        this.form.isLike = 0;
                        this.form.likeCount = this.form.likeCount - 1;
                    } else {
                        this.$message.success("已点赞");
                        this.form.isLike = 1;
                        this.form.likeCount = this.form.likeCount + 1;
                    }
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        userIsCollect() {
            addOrCancel({ collectType: 3, relationId: this.form.courseId }).then(res => {
                if (res.data.code === 1) {
                    if (this.form.isCollect === 1) {
                        this.$message.success("已取消");
                        this.form.isCollect = 0;
                        this.form.collectCount = this.form.collectCount - 1;
                    } else {
                        this.$message.success("已收藏");
                        this.form.isCollect = 1;
                        this.form.collectCount = this.form.collectCount + 1;
                    }
                } else {
                    this.$message.error("操作失败")
                }
            })

        },
        createContent(){
            if (this.content === '') {
                this.$message.error("请输入评论内容")
                return;
            }
            commentCreate({ content: this.content, relationId: this.form.courseId }).then(res => {
                if (res.data.code === 1) {
                    this.content = '';
                    this.form.commentList.unshift(res.data.data)
                    this.$message.success("评论成功");
                } else {
                    this.$message.error("操作失败")
                }
            })
        },
        delComment(item, index) {
            commentDelete({ commentId: item.commentId }).then(res => {
                if (res.data.code === 1) {
                    this.form.commentList.splice(index, 1)
                    this.$message.success("删除成功");
                } else {
                    this.$message.error("操作失败");
                }
            })
        },
        viewVideoFile(){
            this.isVideoFileShow = true;
        },
        handleDownload(item) {
            downloadFile(item.fileUrl, item.fileName)
        },
        handleViewInfo(item) {
            let routeUrl = this.$router.resolve({
                path: '/lessonFileDetail',
                query: { data: JSON.stringify(item) }
            })
            window.open(routeUrl.href, '_blank')
        },
        changeTheme(no){
            if (this.themeNo === no){
                return;
            }
            this.themeNo = no;
            if (this.themeNo === 1){
                this.videoList = this.vList1;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 2){
                this.videoList = this.vList2;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 3){
                this.videoList = this.vList3;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 4){
                this.videoList = this.vList4;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 5){
                this.videoList = this.vList5;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 6){
                this.videoList = this.vList6;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 7){
                this.videoList = this.vList7;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 8){
                this.videoList = this.vList8;
                this.viewVideo(this.videoList[0])
            }
            if (this.themeNo === 9){
                this.videoList = this.vList9;
                this.viewVideo(this.videoList[0])
            }
            this.isTheme = !this.isTheme;
        }
    }
}

</script>

<style scoped>
.course-container{
    width: 100%;
    height: auto;
}
.base-create-container{
    width: 100%;
    height: calc(100vh - 90px);
    background-color: #fff;
    overflow-y: hidden!important;
    font-family: sans-serif;
}
.head-container{
    width: 100%;
    height: 44px;
    display: flex;
    //background-color: #fff;
}
.left-head-container{
    width: 200px;
    height: 44px;
    cursor: pointer;
    padding-left: 10px;
    padding-top: 9px;
}
.l-a{
    font-family: sans-serif;
}
.l-a:hover{
    font-family: sans-serif;
    color: #3b62f8;
    font-weight: bold;
}
.right-head-container{
    width: calc(100% - 400px);
    height: 44px;
    text-align: center;
    font-size: 16px;
    color: #121212;
    line-height: 44px;
    font-weight: bold;
}
.info-container{
    width: 100%;
    height: calc(100% - 50px);
    padding: 5px 10px 10px 10px;
    box-sizing: border-box;
}
.operation-item-container{
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    height: 60px;
    font-size: 15px;
    cursor: pointer;
    padding-top: 100px;
    box-sizing: border-box;
}
.operation-item-icon{
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
}
.operation-item-name{
    text-align: center;
    margin-bottom: 10px;
    font-family: sans-serif;
}
.operation-item-name-active{
    text-align: center;
    margin-bottom: 10px;
    font-family: sans-serif;
    color: #409eff;
}
.video-card{
    height: calc(100vh - 140px);
    overflow: auto;
    position:relative;
}
.v-info{
    height: calc(100vh - 140px);
    overflow: auto;
}
.v-info-content{
    font-size: 15px;
    font-family: sans-serif;
    color: #121212;
}
.v-info-title{
    font-weight: bold;
    font-size: 15px;
    font-family: sans-serif;
    height: 30px;
    line-height: 30px;
}
.v-item{
    margin-bottom: 10px;
    width: 98%;
}

.zsss /deep/ .el-input-group__append {
    padding: 0px !important;
}

/deep/ .el-input-group__append {
    background: var(--el-color-primary);
    color: #fff;
}

.btx {
    min-width: 300px;
    position: absolute;
    left: 60px;
    background: #fff;
    z-index: 999;
}
.theme-container{
    width: auto;
    height: auto;
    margin-bottom: 10px;
    padding: 2px 5px 2px 5px;
    box-sizing: border-box;
    cursor: pointer;
    border-radius: 4px;
}

.theme-container-active{
    width: auto;
    height: auto;
    margin-bottom: 10px;
    padding: 2px 5px 2px 5px;
    box-sizing: border-box;
    background-color: #409eff;
    color: #fff;
    cursor: pointer;
    border-radius: 4px;
}
</style>